import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { levelLabel } from "@/lib/levels";
import { Button } from "@/components/ui/button";
import { FileText, Wand2 } from "lucide-react";

export default function AgendasLibrary() {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    api.get("/agendas/templates").then(({ data }) => setTemplates(data)).catch(() => {});
  }, []);

  const sessions = {};
  templates.forEach((t) => {
    const key = `${t.session_no}::${t.session_name}`;
    (sessions[key] = sessions[key] || []).push(t);
  });

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="agendas-library">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          <span className="text-xs uppercase tracking-[0.22em] font-extrabold text-[#920e12]">Agenda Library</span>
          <h1 className="mt-2 font-display text-4xl text-[#550001]">Pre-built agendas</h1>
          <p className="mt-2 text-[#545454]">Ready-to-run class plans. Open one to view, download, email, or use it as a starting point.</p>
        </div>
        <Button asChild className="bg-[#920e12] hover:bg-[#550001] text-white shrink-0" data-testid="library-build-btn">
          <Link to="/agendas/build"><Wand2 size={16} className="mr-1" /> Build your own</Link>
        </Button>
      </div>

      <div className="mt-10 space-y-10">
        {Object.keys(sessions).sort().map((key) => {
          const [no, name] = key.split("::");
          return (
            <div key={key} data-testid={`library-session-${no}`}>
              <h2 className="font-display text-2xl text-[#1a1617] border-b-2 border-[#920e12] pb-2 mb-4">
                Session {no}: {name}
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {sessions[key].sort((a, b) => a.class_no - b.class_no).map((t) => (
                  <Link key={t.id} to={`/agendas/library/${t.id}`} data-testid={`library-card-${t.id}`}
                    className="group bg-white rounded-2xl border border-[#dfd8da] p-5 hover:border-[#920e12] transition-colors duration-150">
                    <div className="flex items-center justify-between">
                      <span className="text-[10px] uppercase tracking-widest font-extrabold text-[#920e12]">Class {t.class_no}</span>
                      <span className="text-[10px] uppercase tracking-widest font-extrabold text-[#bf6163]">{levelLabel(t.level)}</span>
                    </div>
                    <h3 className="mt-1 text-lg font-bold text-[#1a1617] group-hover:text-[#920e12] leading-snug">{t.title}</h3>
                    <p className="mt-2 text-sm text-[#545454] flex items-center gap-1"><FileText size={14} /> {t.block_count} segments</p>
                  </Link>
                ))}
              </div>
            </div>
          );
        })}
        {templates.length === 0 && <p className="text-[#545454]">No pre-built agendas yet.</p>}
      </div>
    </div>
  );
}
